import { render, staticRenderFns } from "./GPathNotes.vue?vue&type=template&id=7b375354"
import script from "./GPathNotes.vue?vue&type=script&lang=js"
export * from "./GPathNotes.vue?vue&type=script&lang=js"
import style0 from "./GPathNotes.vue?vue&type=style&index=0&id=7b375354&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports